import { useParams } from 'react-router-dom'

import { useGetCreditApplicationBdcOrgID } from './GetCreditApplicationBdcOrgID.gql'

const useBdcOrgID = (appId?: string): [string, Omit<ReturnType<typeof useGetCreditApplicationBdcOrgID>, 'data'>] => {
  const { appId: appIdParam } = useParams()
  const creditApplicationId = appId || appIdParam || ''
  const { data, ...rest } = useGetCreditApplicationBdcOrgID({
    variables: { creditApplicationId },
    skip: !creditApplicationId,
  })
  const bdcOrgId = data?.creditApplication?.bdcOrgId
  return [bdcOrgId ?? '', rest]
}

export default useBdcOrgID
